import { z } from "zod";

/**
 * A calendar date as YYYY-MM-DD — a DATEONLY column, not an instant. Effective
 * and ERP-upload dates come off a vendor notification or a load job, so a
 * timestamp would shift the day across timezones.
 *
 * A leaf module with no other contract imports: `pricelist.contract` and the
 * shared case filters both need it, and `pricelist.contract` imports the
 * filters — a `const` imported back across that edge would be undefined at
 * module evaluation.
 */
export const PricelistDateSchema = z.string().date();
